import { FileItem } from "../file-item";
import { ThirdPartyEvaluationFormItemFile } from "../thirdparty-evaluation-form-item-file";

export const enum FollowUpTaskFormTypeEnum {
  Form,
  File,
  Video,
}

export const enum ThirdPartyFollowUpTaskStatusEnum
{
  Pending = 0,
  CompletedByExternal = 1, // (este se cambia la descripcion de Completed a Completed by external) 
  Messages = 2,
  InProgress= 3,
  CompletedByNewPlan=4, // (nuevo)
  CompletedByClient=5 //(nuevo)
}

export const enum ThirdPartyFollowUpTaskStatusStringEnum
{
  Pending = "Pending",
  CompletedByExternal = "CompletedByExternal", // (este se cambia la descripcion de Completed a Completed by external) 
  Messages = "Messages",
  InProgress= "InProgress",
  CompletedByNewPlan="CompletedByNewPlan", // (nuevo)
  CompletedByClient= "CompletedByClient" //(nuevo)
}
export interface ThirdPartyFollowUpTaskExternalDto {
    thirdPartyFollowUpTaskDto: ThirdPartyFollowUpTaskDto;
    followUpTasksThirdPartyBaseDto: FollowUpTasksThirdPartyBaseDto;
}

export interface FollowUpTasksThirdPartyBaseDto {
  answers: string,
  description: string,
  followUpTaskFormDto: FollowUpTaskFormDto,
  followUpThirdPartyProposalEnum: number,
  followUpThirdPartyResponseEnum: number,
  id: number,
  levelIds: number,
  responsableRole: number,
  thirdPartyTypeIds: number,
  timeLapseConfigId: number
}

export interface FollowUpTaskFormDto {
  approvalPercentage: number,
  countQuestionsForm: number,
  description: string,
  explanation: string,
  files: ThirdPartyEvaluationFormItemFile[],
  followUpTaskAnswerId: number,
  followUpTaskFormItems: FollowUpTaskFormItemDto[],
  followUpTaskFormTypeEnum: FollowUpTaskFormTypeEnum;
  followUpTaskId: number,
  followUpTaskOptionalId: number,
  followUpTaskVideoDto: FollowUpTaskVideoDto,
  id: number,
  numberAttempts: number,
  resultScreen: string,
  resultScreenCleaned: string,
}

export interface FollowUpTaskFormItemDto {
    id: number;
    description: string ;
    itemOrder: number;
    section: string ;
    code: string ;
    explanation: string ;


    parentId: number;

    itemTypeId: number;
    isRequired: boolean;
    isCommentAvailable: boolean;
    isFileAvailable: boolean;

    followUpTaskFormDtoId: number;
    followUpTaskFormItemAnswers: any[];
    followUpTaskFormItemChilds: []
    isChatAvailable: boolean
    keyAutoEvaluate: string;
}

export interface ThirdPartyFollowUpTaskDto {
  active: boolean,
  custom: boolean,
  description: string,
  expirationDate: number,
  expirationType: number,
  id: number,
  idFromFollowUpTaskAppFormAnswer: number,
  idFromMaster: number,
  idFromOptional: number,
  idFromPreviousTask: number,
  thirdPartyFollowUpTaskStatusEnum: ThirdPartyFollowUpTaskStatusEnum,
  thirdPartyFollowUpTaskFormDtos: thirdPartyFollowUpTaskFormDtos[]
}

export interface thirdPartyFollowUpTaskFormDtos{
  approvedDateTime: string
  description: string
  exceedNumberOfAttemps: boolean
  fileDtos:  ThirdPartyEvaluationFormItemFile[]
  finalizedDateResult: string
  followUpTaskFormId: string
  id: number
  thirdPartyEvaluationFollowUpTaskId: number
  thirdPartyFollowUpTaskFormItems: ThirdPartyFollowUpTaskFormItem[];
  thirdPartyFollowUpTaskFormVideoDto: string
}

export interface FollowUpTaskVideoDto {
  description: string,
  files: FileItem[],
  followUpTaskFormId: number,
  id: number,
  linkToVideo?: string,
  manualFile: FileItem,
  videoFile?: FileItem,
}

export interface ThirdPartyFollowUpTaskFormItem {
  observation?: string;
  answers: ThirdPartyFollowUpTaskFormItemAnswer[];
  childs: []
  description: string;
  fileDtos: []
  followUpTaskFormItemId: number
  id: number
  inputText: string
  inputTextList: string
  thirdPartyFollowUpTaskFormId: number
  thirdPartyFollowUpTaskFormParentId: number
}

export interface ThirdPartyFollowUpTaskFormItemAnswer {
  description?: string,
  followUpTaskFormItemAnswerId: number
  id: number
  thirdPartyFollowUpTaskFormItemId: number
}
